import React from 'react'
import './footer-loving.scss'
import { StaticImage } from 'gatsby-plugin-image'

const FooterLoving = () => {
  return (
    <footer className="f-footer-loving">
      <div className="wrapper-logo">
        <StaticImage
          src="../../../assets/images/footer.png"
          width={133}
          height={125}
          alt="logoLoving"
        />
      </div>
    </footer>
  )
}

export default FooterLoving
